import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { MenuItem } from '../interfaces/menu-item.interface';
import { trackById } from '@vex/utils/track-by';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CiudUserAuthData, UserAuthData } from 'src/app/core/auth/authData.model';
import { AuthService } from 'src/app/core/auth/auth.service';
import { Observable } from 'rxjs';

export interface OnlineStatus {
  id: 'online' | 'away' | 'dnd' | 'offline';
  label: string;
  icon: string;
  colorClass: string;
}

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatMenuModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    NgClass,
    NgIf
  ]
})
export class ToolbarUserDropdownComponent implements OnInit {
  currentUser: UserAuthData | CiudUserAuthData | null = null;

  items: MenuItem[] = [
    {
      id: '1',
      icon: 'mat:account_circle',
      label: 'Mi Perfil',
      description: 'Información personal',
      colorClass: 'text-teal-600',
      route: '/opciones-usuario/perfil'
    },
    // {
    //   id: '2',
    //   icon: 'mat:monetization_on',
    //   label: 'Medios de pago',
    //   description: 'Selecciona entre los medios de pago disponibles',
    //   colorClass: 'text-primary-600',
    //   route: '/options-user/payment-methods'
    // },
    // {
    //   id: '3',
    //   icon: 'mat:notifications',
    //   label: 'Recordatorios',
    //   description: 'Historial de recordatorios',
    //   colorClass: 'text-purple-600',
    //   route: '/options-user/reminders'
    // }
  ];

  statuses: OnlineStatus[] = [
    {
      id: 'online',
      label: 'En línea',
      icon: 'mat:check_circle',
      colorClass: 'text-green-600'
    },
    {
      id: 'away',
      label: 'Away',
      icon: 'mat:access_time',
      colorClass: 'text-orange-600'
    },
    {
      id: 'dnd',
      label: 'No molestar',
      icon: 'mat:do_not_disturb',
      colorClass: 'text-red-600'
    },
    {
      id: 'offline',
      label: 'Desconectado',
      icon: 'mat:offline_bolt',
      colorClass: 'text-gray-600'
    }
  ];

  activeStatus: OnlineStatus = this.statuses[0];

  trackById = trackById;

  constructor(
    private cd: ChangeDetectorRef,
    private popoverRef: VexPopoverRef<ToolbarUserDropdownComponent>,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.currentUser = this.authService.getCurrentUser();
  }

  ngDoCheck() {
    this.currentUser = this.authService.getCurrentUser();
  }

  setStatus(status: OnlineStatus) {
    this.activeStatus = status;
    this.cd.markForCheck();
  }

  close() {
    this.popoverRef.close();
  }

  logout() {
    this.authService.logout();
    this.popoverRef.close();
  }
}
